import { useEffect } from 'react';

/**
 * Hook SEO pour gérer les meta tags dynamiquement
 * Résout les problèmes de:
 * - Duplicate without user-selected canonical
 * - Alternate page with proper canonical tag
 */
export const useSEO = ({ 
  title, 
  description, 
  canonical, 
  hreflang = null,
  noindex = false 
}) => {
  useEffect(() => {
    // Update title
    if (title) {
      document.title = title;
    }

    // Update meta description
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = description;
    }

    // Update canonical URL
    if (canonical) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.href = canonical;
    }

    // Update robots meta
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.name = 'robots';
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.content = noindex 
      ? 'noindex, nofollow' 
      : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';

    // Handle hreflang for multilingual pages
    if (hreflang) {
      // Remove existing hreflang links
      document.querySelectorAll('link[hreflang]').forEach(el => el.remove());
      
      // Add new hreflang links
      Object.entries(hreflang).forEach(([lang, url]) => {
        const link = document.createElement('link');
        link.rel = 'alternate';
        link.hreflang = lang;
        link.href = url;
        document.head.appendChild(link);
      });
    }

    // Cleanup function
    return () => {
      // Hreflang links will be replaced by next page
    };
  }, [title, description, canonical, hreflang, noindex]);
};

export default useSEO;
